import { getBaseLayout } from "../../../../lib/designer/utils/layout";
import { simpleJoinPath } from "../../../../lib/utils/string";
export function getFormAutoEditorConversions({
  instance,
  replaceCompWith,
  uc,
  designer
}) {
  const stub = instance === null || instance === void 0 ? void 0 : instance.dataStub;
  if (!stub) return [];
  const dataPath = stub.path;
  const ans = [];
  // 转纯文本
  if (stub.type === 'string' || stub.type === 'number' || stub.type === 'integer') {
    ans.push({
      title: '转文本',
      desc: '转为纯文本展示',
      icon: 'fa fa-font',
      execute: () => replaceCompWith({
        type: 'w-text',
        bindings: {
          文本内容: dataPath
        },
        props: {
          text: `{{ ${simpleJoinPath('data', dataPath)} }}`
        }
      })
    });
  }
  // 卡片和tab
  if (stub.type === 'array') {
    const getArrayItemContent = () => ({
      type: 'markdown',
      props: {
        align: 'center',
        source: '这里是卡片内容\n\n请双击编辑'
      }
    });
    ans.push({
      title: '卡片列表',
      desc: '转为卡片列表',
      icon: 'fa fa-th',
      execute: async () => {
        await replaceCompWith({
          type: 'w-array',
          bindings: {
            数据源: dataPath
          },
          scopedSlots: {
            item: {
              layout: getBaseLayout(uc, 'scopedSlotRoot', [{
                type: 'w-card',
                props: {
                  title: '第 {{ data.num }} 项'
                },
                children: [getArrayItemContent()]
              }])
            }
          }
        });
      }
    });
    ans.push({
      title: 'Tab列表',
      desc: '转为Tab列表，一页一条数据',
      icon: 'fa fa-folder-o',
      execute: async () => {
        await replaceCompWith({
          type: 'w-array-tabs',
          bindings: {
            数据源: dataPath
          },
          scopedSlots: {
            item: {
              layout: {
                type: 'w-tab-pane',
                props: {
                  title: '第 {{ data.num }} 项'
                },
                children: [getArrayItemContent()]
              }
            }
          }
        });
      }
    });
  }
  ans.push({
    title: '转换为普通表单',
    desc: '将当前组件打散变为普通表单',
    place: ['propPanel'],
    icon: 'fa fa-folder-open-o',
    execute: () => {
      // @ts-ignore
      designer.$refs.editZone.$el.focus();
      setTimeout(() => {
        const instance = designer.activeCompInstance;
        designer.replaceCompWith(designer.compPath, {
          ...designer.activeComp,
          // @ts-ignore
          ...instance.currentLayout
        });
      }, 200);
    }
  });
  return ans;
}